import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import { RootState } from "../../store";
import { selectAuthToken } from "@store/sessionReducer";

// TODO: move to env variables
const getBaseUrl = () => {
  if (window.location.origin.includes("localhost")) {
    return "http://localhost:5027";
  }

  if (window.location.origin.includes("staging")) {
    return "//visit-widget-backend-99018169515.us-central1.run.app";
  }

  return "//api.visitwidget.com";
};

// must include origin for `msw` to work, which is used for mocking api.
const backendBaseUrl =
  getBaseUrl() + `/api/clients/${VisitWidget.settings.currentClientId}`;

const baseQuery = fetchBaseQuery({
  baseUrl: backendBaseUrl,
  prepareHeaders: (headers, { getState }) => {
    const token = selectAuthToken(getState() as RootState);

    if (token) {
      const authHeader = `Bearer ${token}`;
      headers.set("Authorization", authHeader);
    }

    return headers;
  },
});

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 1 });

const backendApi = createApi({
  reducerPath: "backendApi",
  baseQuery: baseQueryWithRetry,
  /**
   * This api has endpoints injected in adjacent files,
   * which is why no endpoints are shown below.
   */
  endpoints: () => ({}),
  tagTypes: [],
});

export { backendApi, backendBaseUrl };
